import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Typography, FormControl, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LoadingBox } from "@northpowerdev/np-react-utils";
import { useState } from "react";
import { GrayTextField } from "../../../utils/GrayTextField";
import { isValidDateObject } from "../../../utils/utilityFunctions";
import { parseISO } from "date-fns";

export function WorkOrderSetStatusDialog({workOrderNumber, currentStatus, newStatusList,
        currentScheduledDate, currentOnHoldReason,
        open, onClose, onSave, onHoldReasonList,
        closeLabel = 'Cancel', saveLabel = 'Update Status'}) {

    //
    // Initial values for onHoldReason, newStatus and scheduledDate are set to empty string.
    // Leaving them undefined gives the error:
    // 'A component is changing the uncontrolled value state of Select to be controlled.'
    //
    const [onHoldReason, setOnHoldReason] = useState(currentOnHoldReason || '')
    const [newStatus, setNewStatus] = useState(currentStatus || '') 
    const [scheduledDate, setScheduledDate] = useState(parseISO(currentScheduledDate) || '') // Could throw an error
    const [pageLoading, setPageLoading] = useState(false)
    const handleCloseClick = (event) => {
        if (typeof(onClose) == 'function') {
            onClose()
        }
    }

    const handleSaveClick = async (event) => {
        if (typeof(onSave) == 'function') {
            setPageLoading(true)
            const success = await onSave(newStatus, onHoldReason, scheduledDate) // Returns boolean letting you know if save was successful.
            console.log('WorkOrderSetStatusDialog handleSaveClick done onSave')
            setPageLoading(false)
            if (success) {
                console.log('WorkOrderSetStatusDialog handleSaveClick onSave succeeded, closing dialog')
                // Status change succeeded so we can close the dialog
                onClose()
            }
        }
    }

    const handleNewStatusChange = (event) => {
        const theNewStatus = event.target.value
        console.log('handleNewStatusChange', theNewStatus)
        setNewStatus(theNewStatus)
        if (theNewStatus !== 'On Hold With Contractor') {
            setOnHoldReason('')
        }
        if (theNewStatus !== 'Scheduled') {
            setScheduledDate(null)
        }
    }

    const handleOnHoldReasonChange = (event) => {
        console.log('handleOnHoldReasonChange', event.target.value)
        setOnHoldReason(event.target.value)
    }

    const handleScheduledDateChange = (newValue) => {
        console.log('handleScheduledDateChange', newValue)
        setScheduledDate(newValue)
    }

    if (!workOrderNumber) {
        return null
    }

    //
    // This is effectively form validation. If it gets any more complicated we need to use a validator.
    //
    const isValidOnHoldReason = (onHoldReasonList?.length === 0 || onHoldReason)
    const dateToday = (new Date()).setHours(0, 0, 0, 0) // midnight at the start of today
    const isValidScheduledDate = isValidDateObject(scheduledDate) && (scheduledDate >= dateToday)
    const isSaveEnabled = (
        newStatus === 'Inspections Team' 
        ||
        (newStatus === 'On Hold With Contractor' && isValidOnHoldReason)
        ||
        (newStatus === 'Scheduled' && isValidScheduledDate)
    )

    return (
        <Dialog open={open} onClose={handleCloseClick} scroll="paper" fullWidth>
            <DialogTitle>
                Change status for work order {workOrderNumber}.
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{my: 1}}>
                    <Typography variant="body1">Current status <strong>{currentStatus}</strong>.</Typography>
                    {/* <Typography variant="body1">You can change status to <strong>{newStatusList.join(', ')}</strong>.</Typography> */}

                    {
                        newStatusList?.length > 0
                        ?
                            <FormControl fullWidth sx={{my: 2}}>
                                <GrayTextField
                                    select
                                    value={newStatus}
                                    label="New Status *"
                                    variant="outlined"
                                    onChange={handleNewStatusChange}
                                >
                                    {newStatusList.map((thisStatus) => (
                                        <MenuItem key={thisStatus} value={thisStatus}>
                                            {thisStatus}
                                        </MenuItem>
                                    ))}
                                </GrayTextField>
                            </FormControl>
                        :
                        null
                    }

                    {
                        (newStatus === 'On Hold With Contractor' && onHoldReasonList?.length > 0)
                        ?
                            <FormControl fullWidth sx={{my: 2}}>
                                <GrayTextField
                                    select
                                    value={onHoldReason}
                                    label="On Hold Reason *"
                                    variant="outlined"
                                    onChange={handleOnHoldReasonChange}
                                    // helperText=""
                                >
                                    {onHoldReasonList && onHoldReasonList.map((thisReason) => (
                                        <MenuItem key={thisReason} value={thisReason}>
                                            {thisReason}
                                        </MenuItem>
                                    ))}
                                </GrayTextField>
                            </FormControl>
                        :
                        null
                    }


                    {
                        (newStatus === 'Scheduled')
                        ?
                            <FormControl fullWidth sx={{my: 2}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    disablePast
                                    disableMaskedInput
                                    label="Scheduled Date *"
                                    value={scheduledDate}
                                    format="d MMMM yyyy"
                                    onChange={handleScheduledDateChange}
                                    renderInput={(params) => <GrayTextField {...params} />}
                                />
                                </LocalizationProvider>
                            </FormControl>
                        :
                        null
                    }
                </Box>
                
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button onClick={handleCloseClick}>{closeLabel}</Button>
                <LoadingBox loading={pageLoading} message="Saving"  sx={{marginLeft: 'auto'}}>
                    <Button variant="contained" onClick={handleSaveClick}  disabled={!isSaveEnabled}>{saveLabel}</Button>
                </LoadingBox>
            </DialogActions>
        </Dialog>
    )
}

